import { ReactNode } from 'react';
import { Button } from '@/common/components/ui/button';
import { useFormContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import { useShowLoadingDelayed } from '@/common/hooks/useShowLoadingDelayed.ts';
import { Loader2 } from 'lucide-react';

export interface FormSubmitProps {
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  type?: 'submit' | 'button' | 'reset';
}

export const FormSubmit = ({ children, disabled, className }: FormSubmitProps) => {
  const form = useFormContext();
  const isSubmitting = useStore(form.store, (state) => state.isSubmitting);
  const showLoading = useShowLoadingDelayed(isSubmitting);

  return (
    <Button type="submit" disabled={isSubmitting || disabled} className={className}>
      {showLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
};
